// src/api/verification.ts
import { apiClient } from './client';

export const verificationAPI = {
    sendPhoneVerification: (phone: string, purpose: 'login' | 'verify' = 'login') =>
        apiClient.post('/phone-verification/send/', { phone, purpose }),
    
    verifyPhone: (phone: string, code: string) =>
        apiClient.post('/phone-verification/verify/', { phone, code }),

    verifyPhoneAndLogin: (phone: string, code: string) =>
        apiClient.post('/phone-verification/verify-and-login/', { phone, code }),

    sendEmailVerification: (email: string) =>
        apiClient.post('/email-verification/send/', { email }),

    verifyEmail: (email: string, code: string) =>
        apiClient.post('/email-verification/verify/', { email, code }),
};
